export function isNullEmptyOrUndefined (str) {
    return str === undefined || str === null || str === "";
}
export function areEquivalent (a: string, b: string) {
    if (a && b) {
        return a.localeCompare(b, "en", { sensitivity: "base" }) === 0;
    }
    return false;
}
export function truncateIfTooSmallForWidth (text: string) {
    const widthPerCharNeeded = 10;
    const maxLength = Math.round(window.innerWidth / 10) - 3;
    if (window.innerWidth < text.length * widthPerCharNeeded) {
        return text.slice(0, maxLength) + "...";
    }
    return text;
}